// extracted by mini-css-extract-plugin
module.exports = {"active":"header-module--active--2pIok","link":"header-module--link--3nE3Q"};